import { render, staticRenderFns } from "./HolidayManagement.vue?vue&type=template&id=0a2ef3c2&scoped=true"
import script from "./HolidayManagement.vue?vue&type=script&lang=js"
export * from "./HolidayManagement.vue?vue&type=script&lang=js"
import style0 from "./HolidayManagement.vue?vue&type=style&index=0&id=0a2ef3c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2ef3c2",
  null
  
)

export default component.exports